<template>
<div class="new-promotion-navigation">
	<div class="first-item" v-for="(first,firstIndex) in navList" :key="firstIndex" v-show="first.status!='disabled'">
		<div class="first-item-title"
		     :class="firstIndex==currentIndex?first.status+' current':first.status"
		     @click="$emit('on-click-first-nav',firstIndex)">{{first.title}}
		</div>
		<div v-show="first.status=='active'" class="second-list">
			<div class="second-item"
			     v-for="(second,secondIndex) in first.children"
				 :key="secondIndex"
			     :class="{active:second.active}"
                 @click="$emit('on-click-second-nav',{firstIndex,hash:second.hash})">
                 <span>{{second.title}}</span>
				 <i class="icon-check"></i>
			</div>
		</div>
	</div>
    <p class="return-btn"><span @click="$emit('on-click-return')">取消</span></p>
</div>
</template>
<script>
export default {
    name: '',
    props: {
        currentIndex: {
            type: Number,
            default: 0,
        },
        navList: {
            type: Array,
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped>
@import 'src/style/frequently.scss';
.new-promotion-navigation {
    box-sizing: border-box;
    height: calc(100vh - 1.3rem);
    min-height: 5rem;
    //返回按钮
    .return-btn {
        position: absolute;
        bottom: 0.6rem;
        text-align: center;
        width: 100%;
        color: #888888;
        font-size: 0.16rem;
        span {
            cursor: pointer;
        }
    }
    //一级导航
    .first-item {
        padding-left: 0.47rem;
        margin-bottom: 0.45rem;
        //一级导航标题
        .first-item-title {
            font-size: 0.2rem;
            // font-weight: bold;
            line-height: 0.26rem;
            padding-left: 0.21rem;
            position: relative;
            border-left: 0.03rem solid #fff;
            color: $mdTitColor;
            &.active {
                cursor: pointer;
            }
            &.disable,
            &.notActive {
                color: #888;
                cursor: no-drop;
            }
            &.current {
                border-left: 0.03rem solid $impColor;
            }
        }
        //二级导航列表
        .second-list {
            //二级导航
            .second-item {
                margin-top: 0.2rem;
                color: #888;
                font-size: 0.16rem;
                line-height: 0.22rem;
                padding-left: 0.39rem;
                position: relative;
                cursor: pointer;
                &.active {
                    color: $mdTitColor;
                    .icon-check {
                        display: inline-block;
                        width: 0.09rem;
                        height: 0.07rem;
                        margin-top: -0.02rem;
                        background-image: url('../../assets/img/common/sprit.png');
                        background-size: 4.4rem 3.2rem;
                        background-repeat: no-repeat;
                        background-position: -2.91rem -2.1rem;
                    }
                }
            }
        }
    }
}
@media screen and(max-height: 800px) {
    .new-promotion-navigation {
        .first-item {
            margin-bottom: 0.25rem;
            .second-item {
                margin-top: 0.15rem;
            }
        }
        .return-btn {
            margin-bottom: 0.25rem;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/NewPromotion/navigation.vue